import { useEffect, useState } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import validate from './TimeStandardAgeGroupAddValidation';

import useTimeStandardData from '../../../state/timeStandard/UseTimeStandardData';

import useForm from '@usas/ui-web/utils/UseForm';
import useSecurityData from '@usas/ui-web/state/security/UseSecurityData';

import NavLinks from '../NavLinks';

const DUPLICATE_AGE_GROUP_NAME_ERROR = 'The provided age group name and bonus selection matches the name and bonus selection of an existing age group. Duplicate name and bonus selections are not allowed.';

const useTimeStandardAgeGroupAdd = () => {
  const navigate = useNavigate();
  const [state, setState] = useState({ tryRedirect: false });
  const { getContextSecurity } = useSecurityData();
  const { timeStandardState, putTimeStandard } = useTimeStandardData();
  const { errorState, setErrors, formState, handleSubmit, onFormValueChanged, setFormData, setIsDirty,
    isSubmitting } = useForm(getInitialFormState, submitFormCallback, validate);

  const validateAgeGroup = (timeStandardCopy) => {
    //Check for dupes
    let duplicateAgeGroupNames = false;
    for (let i = 0; i < timeStandardCopy.timeStandardAgeGroup.length; i++) {
      if (timeStandardCopy.timeStandardAgeGroup[i].ageGroupName === formState.ageGroupName &&
        timeStandardCopy.timeStandardAgeGroup[i].isBonus === formState.isBonus) {
        duplicateAgeGroupNames = true;
      }
    }
    if (duplicateAgeGroupNames === true) {
      setErrors({ ...errorState, duplicateNames: DUPLICATE_AGE_GROUP_NAME_ERROR });
      return false;
    }
    return true;
  }

  const editTimeStandardObj = () => {
    let timeStandardCopy = JSON.parse(JSON.stringify(timeStandardState.objData));
    if (timeStandardCopy.timeStandardAgeGroup.length > 0) {
      if (validateAgeGroup(timeStandardCopy) === true) {
        timeStandardCopy.timeStandardAgeGroup.push({
          timeStandardId: timeStandardCopy.timeStandardId,
          minAge: parseInt(formState.minAge),
          maxAge: parseInt(formState.maxAge),
          ageGroupName: formState.ageGroupName.trim(),
          isBonus: formState.isBonus,
          timeStandardCut: []
        });

        return timeStandardCopy;
      }
      else {
        return null;
      }
    }
    else if (timeStandardCopy.timeStandardAgeGroup.length === 0) {
      timeStandardCopy.timeStandardAgeGroup.push({
        timeStandardId: timeStandardCopy.timeStandardId,
        minAge: parseInt(formState.minAge),
        maxAge: parseInt(formState.maxAge),
        ageGroupName: formState.ageGroupName.trim(),
        isBonus: formState.isBonus,
        timeStandardCut: []
      });

      return timeStandardCopy;
    }
  }

  function submitFormCallback(formState) {
    const editedTimeStandardObj = editTimeStandardObj();
    if (editedTimeStandardObj !== null) {
      putTimeStandard(timeStandardState.objData.timeStandardId, editTimeStandardObj());
      setState({ ...state, tryRedirect: true });
    }
  }

  const onCancelClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    navigate(NavLinks.TIME_STANDARDS_AGE_GROUP);
  }

  useEffect(() => {
    getContextSecurity(timeStandardState.objData.timeStandardId, 'Times');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setFormData({
      ...formState,
      ageGroupName: 'Open',
      isBonus: false,
      minAge: '1',
      maxAge: '99'
    });
    setIsDirty(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (state.tryRedirect === true && timeStandardState.isObjLoaded === true && isSubmitting === false) {
      navigate(NavLinks.TIME_STANDARDS_AGE_GROUP);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.tryRedirect, timeStandardState.isObjLoaded, isSubmitting])

  return {
    timeStandardState,
    formState,
    errorState,
    handleSubmit,
    onFormValueChanged,
    onCancelClicked
  }
};

export default useTimeStandardAgeGroupAdd;

function getInitialFormState() {
  return {
    ageGroupName: '',
    isBonus: '',
    minAge: '',
    maxAge: ''
  };
};